<template>
  <div :class="className">
    <div class="left_label">{{label}}：</div>
    <div class="right_content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'aLineInfo',
  props: {
    label: {
      default: ''
    },
    className: {
      default: 'a_line'
    }
  }
}
</script>

<style scoped lang="scss">
  .left_label {
    width: 115px;
    margin-right: 2px;
    padding: 5px 0;
    box-sizing: border-box;
  }
  .right_content {
    //border-left: 1px solid #d0d0d0;
    min-height: 100%;
    padding: 5px 0px;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/aLineInfo.vue